export default {
    VALID: "VALID",
    WARNING: "WARNING",
    ERROR: "ERROR"
}